import React from 'react';

const Process = () => {
  return (
    <>
      {/* <!-- Process --> */}
      <section className='relative pb-24 dark:bg-jacarta-800'>
        <picture className='pointer-events-none absolute inset-0 -z-10 dark:hidden'>
          <img src='/images/gradient_light.jpg' alt='gradient' className='h-full w-full' />
        </picture>
        <div className='container'>
          <h2 className='mb-10 text-center font-display text-3xl text-jacarta-700 dark:text-white'>
            Edit your collection in 3 steps.
          </h2>
          <div className='grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3'>
            <div className='rounded-2.5xl relative border border-jacarta-100 bg-white p-10 shadow-[0_5px_0_0_#8358ff] transition-shadow hover:shadow-[0_16px_24px_-8px_rgba(131,88,255,.3)] dark:border-jacarta-700 dark:bg-jacarta-700'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 24 24'
                width='24'
                height='24'
                className='absolute right-3 top-3 h-16 w-16 fill-jacarta-50 dark:fill-jacarta-600'
              >
                <path fill='none' d='M0 0h24v24H0z' />
                <path d='M22 6h-7a6 6 0 1 0 0 12h7v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2zm-7 2h8v8h-8a4 4 0 1 1 0-8zm0 3v2h3v-2h-3z' />
              </svg>
              <div className='mb-6 inline-flex items-center justify-center'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 24 24'
                  width='24'
                  height='24'
                  className='h-12 w-12 fill-accent'
                >
                  <path fill='none' d='M0 0h24v24H0z' />
                  <path d='M22 6h-7a6 6 0 1 0 0 12h7v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2zm-7 2h8v8h-8a4 4 0 1 1 0-8zm0 3v2h3v-2h-3z' />
                </svg>
              </div>
              <h3 className='mb-4 font-display text-lg text-jacarta-700 dark:text-white'>
                Connect to Bit5 with the collection owner's wallet
              </h3>
              <p className='dark:text-jacarta-300'>
                Connect to Bit5 with the wallet of the owner of your collection and you will see an
                'Edit' section for your collection. Only the owners of the collection can see this
                section. Click 'Edit'.
              </p>
            </div>
            <div className='rounded-2.5xl relative border border-jacarta-100 bg-white p-10 shadow-[0_5px_0_0_#10b981] transition-shadow hover:shadow-[0_16px_24px_-8px_rgba(16,185,129,.3)] dark:border-jacarta-700 dark:bg-jacarta-700'>
              <svg
                viewBox='0 0 24 24'
                width='24'
                height='24'
                className='absolute right-3 top-3 h-16 w-16 fill-jacarta-50 dark:fill-jacarta-600'
                xmlns='http://www.w3.org/2000/svg'
              >
                <g id='Edit'>
                  <g>
                    <path d='M3.548,20.938h16.9a.5.5,0,0,0,0-1H3.548a.5.5,0,0,0,0,1Z' />
                    <path d='M9.71,17.18a2.587,2.587,0,0,0,1.12-.65l9.54-9.54a1.75,1.75,0,0,0,0-2.47l-.94-.93a1.788,1.788,0,0,0-2.47,0L7.42,13.12a2.473,2.473,0,0,0-.64,1.12L6.04,17a.737.737,0,0,0,.19.72.767.767,0,0,0,.53.22Zm.41-1.36a1.468,1.468,0,0,1-.67.39l-.97.26-1-1,.26-.97a1.521,1.521,0,0,1,.39-.67l.38-.37,1.99,1.99Zm1.09-1.08L9.22,12.75l6.73-6.73,1.99,1.99Zm8.45-8.45L18.65,7.3,16.66,5.31l1.01-1.02a.748.748,0,0,1,1.06,0l.93.94A.754.754,0,0,1,19.66,6.29Z' />
                  </g>
                </g>
              </svg>
              <div className='mb-6 inline-flex items-center justify-center'>
                <svg
                  viewBox='0 0 24 24'
                  width='24'
                  height='24'
                  className='h-12 w-12 fill-green'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <g id='Edit'>
                    <g>
                      <path d='M3.548,20.938h16.9a.5.5,0,0,0,0-1H3.548a.5.5,0,0,0,0,1Z' />
                      <path d='M9.71,17.18a2.587,2.587,0,0,0,1.12-.65l9.54-9.54a1.75,1.75,0,0,0,0-2.47l-.94-.93a1.788,1.788,0,0,0-2.47,0L7.42,13.12a2.473,2.473,0,0,0-.64,1.12L6.04,17a.737.737,0,0,0,.19.72.767.767,0,0,0,.53.22Zm.41-1.36a1.468,1.468,0,0,1-.67.39l-.97.26-1-1,.26-.97a1.521,1.521,0,0,1,.39-.67l.38-.37,1.99,1.99Zm1.09-1.08L9.22,12.75l6.73-6.73,1.99,1.99Zm8.45-8.45L18.65,7.3,16.66,5.31l1.01-1.02a.748.748,0,0,1,1.06,0l.93.94A.754.754,0,0,1,19.66,6.29Z' />
                    </g>
                  </g>
                </svg>
              </div>
              <h3 className='mb-4 font-display text-lg text-jacarta-700 dark:text-white'>
                Edit your collection royalty and other information.
              </h3>
              <p className='dark:text-jacarta-300'>
                On the Edit page, enter the roylaty value of your collection. You can also edit
                other information about your collection.
              </p>
            </div>
            <div className='rounded-2.5xl relative border border-jacarta-100 bg-white p-10 shadow-[0_5px_0_0_#ef4444] transition-shadow hover:shadow-[0_16px_24px_-8px_rgba(239,68,68,.3)] dark:border-jacarta-700 dark:bg-jacarta-700'>
              <svg
                viewBox='0 0 512 512'
                width='24'
                height='24'
                className='absolute right-3 top-3 h-16 w-16 fill-jacarta-50 dark:fill-jacarta-600'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path d='M256 16C123.5 16 16 123.5 16 256c0 132.6 107.5 240 240 240 132.6 0 240-107.4 240-240S388.6 16 256 16zm0 60c99.4 0 180 80.6 180 180s-80.6 180-180 180S76 355.4 76 256 156.6 76 256 76zm91.3 64.2c-6.5 0-12.5 2.4-16.8 8.2-52 70.1-69 96.5-106 169.8-8.4-11.1-65.6-72.4-93.9-94.1-14.2-10.9-41.3 27.2-31.6 37.1C142.6 306.1 220.1 406 232.7 405c21.4-1.7 75.1-136.8 148.8-233.7 8-10.4-15-31.3-34.2-31.1z' />
              </svg>
              <div className='mb-6 inline-flex items-center justify-center'>
                <svg
                  viewBox='0 0 512 512'
                  width='24'
                  height='24'
                  className='h-12 w-12 fill-red'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path d='M256 16C123.5 16 16 123.5 16 256c0 132.6 107.5 240 240 240 132.6 0 240-107.4 240-240S388.6 16 256 16zm0 60c99.4 0 180 80.6 180 180s-80.6 180-180 180S76 355.4 76 256 156.6 76 256 76zm91.3 64.2c-6.5 0-12.5 2.4-16.8 8.2-52 70.1-69 96.5-106 169.8-8.4-11.1-65.6-72.4-93.9-94.1-14.2-10.9-41.3 27.2-31.6 37.1C142.6 306.1 220.1 406 232.7 405c21.4-1.7 75.1-136.8 148.8-233.7 8-10.4-15-31.3-34.2-31.1z' />
                </svg>
              </div>
              <h3 className='mb-4 font-display text-lg text-jacarta-700 dark:text-white'>
                Update your collection royalty and other information.
              </h3>
              <p className='dark:text-jacarta-300'>Now, just update your changes. That's all.</p>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- end process --> */}
    </>
  );
};

export default Process;
